exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".error-modal-body {\n  min-height: 100px;\n  background-color: white;\n  padding: 20px;\n  border-bottom-right-radius: 19px;\n  border-bottom-left-radius: 19px; }\n  .error-modal-body .message-text {\n    font-size: 16px;\n    color: #4a4a4a;\n    font-family: Montserrat; }\n  .error-modal-body .error-text {\n    text-align: center; }\n  .error-modal-body .okay-button {\n    position: absolute;\n    margin-right: 20px;\n    margin-bottom: 20px;\n    bottom: 0;\n    right: 0;\n    padding: 10px 40px; }\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/sass-loader/lib/loader.js!./src/components/ShoutoutNotFoundModal.scss
// module id = 858
// module chunks = 0